import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopPageView').create(({ theme }) => ({
  root: {
    display: 'flex',
    position: 'relative',
    width: '100vw',
    flexDirection: 'column',
    alignItems: 'start',
    padding: '16px',
    gap: '16px',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: '15vh',
    height: '100vh',

    '&[data-ismodalopen="true"]': {
      pointerEvents: 'auto',
    },

    '& #key-modal-window': {
      filter: 'none',
      pointerEvents: 'auto',
      isolation: 'isolate',
    },
  },

  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: '998',
    pointerEvents: 'none',
  },

  expensiveWithHeadingnWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
    opacity: 1,
  },

  rewardListWrapper: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '8px',
  },

  otherWithHeadingWrapper: {
    display: 'grid',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
  },

  otherRewardsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: '8px',
    flexWrap: 'wrap',
  },

  expensiveText: {
    width: '100%',
    fontFamily: 'Inter',
    fontWeight: 270,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,
    textTransform: 'uppercase',
    color: theme.colors.text.secondary,
  },

  otherText: {
    fontFamily: 'Inter',
    fontWeight: 270,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
  },

  descrption: {
    fontFamily: 'Inter',
    fontWeight: 250,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.secondary,
  },

  keyModalWindowWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    height: 'auto',
    zIndex: '999',
    position: 'fixed',
    bottom: '16px',
    left: '0',
  },

  description: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    h1: {
      fontWeight: '450',
      fontSize: theme.sizes.texts.fontSize.l,
      lineHeight: theme.sizes.texts.lineHeight.xl,

      margin: '0',
      color: theme.colors.text.primary,
    },

    p: {
      color: theme.colors.text.secondary,
      fontWeight: '350',
      margin: '0',
      fontSize: theme.sizes.texts.fontSize.m,
      lineHeight: theme.sizes.texts.lineHeight.xl,
    },
  },
}))
